/** research-api caps a product slug at 64 characters. */
export const PRODUCT_SLUG_MAX_LENGTH = 64;

/**
 * The kebab-case slug research-api accepts (`^[a-z0-9]+(?:-[a-z0-9]+)*$`), derived from a product name.
 * Accented letters become their base letter ("Café" → "cafe"); any other run of characters outside a-z
 * and 0-9 — `&`, spaces, punctuation — becomes one hyphen. A name with no letters or digits comes back
 * empty, which the caller must refuse to save.
 */
export function productSlug(name: string): string {
  return name
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, PRODUCT_SLUG_MAX_LENGTH)
    .replace(/-+$/, "");
}
